"use strict"

import { getUserFavoritesCount } from '../utils/favorites';

export function init() {
    const SELECTOR = '.js-favorites-status';
    const INNER = '.favorites-number';

    const element = document.querySelector(SELECTOR);

    if (element === null) {
        return false;
    }

    const noFavoritesLink = element.dataset.noFavoritesLink;
    const favoritesLink = element.dataset.favoritesLink;

    const updateFavoriteText = e => {
        let promise;

        if (e && e.detail) {
            promise = Promise.resolve(e.detail);
        } else {
            promise = getUserFavoritesCount();
        }

        promise.then(count => {
            element.querySelector(INNER).textContent = count;

            if (count) {
                element.setAttribute('href', favoritesLink);
                element.querySelector(INNER).classList.remove('toggle');
            } else {
                element.setAttribute('href', noFavoritesLink);
                element.querySelector(INNER).classList.add('toggle');
            }
        });
    };


    const checkIsFavoritesView = () => {
        const queries = {};
    
        new URL(location.href).searchParams.forEach((value, key) => {
            queries[key] = value;
        });
    
        const isFavoritesView = 'View' in queries && queries.View === 'Favorites';
    
        if (isFavoritesView) {
            element.classList.add('js-favorites-view');
        } else {
            element.classList.remove('js-favorites-view');
        }
    }    

    window.addEventListener('favorites', updateFavoriteText);
    
    checkIsFavoritesView();
    updateFavoriteText();
}

export default { init }
